import { defaultFemaleVoice } from '@listening/api-contract/legacy-client-types';
import iconSpeakSvg from '@listening/assets/astro/icons/blog/icon-speak.svg';
import freeTrialBannerPng from '@listening/assets/astro/images/free-trial-banner.png';
import voiceLeslieJpg from '@listening/assets/astro/images/voice-avatars/voice-leslie.jpg';

import { VoiceSample } from '@/components/astro/features/voice-sample';
import { BlogCtaButton } from './blog-cta-button';

export function FreeTrialBanner({ className }: { className?: string }) {
  return (
    <section className='not-prose'>
      <div
        className={`${className ?? ''} @media(max-width:767px)]:bg-none inline-flex w-full flex-col items-center justify-center gap-8 overflow-hidden rounded-3xl bg-cover bg-no-repeat px-5 pt-6 pb-8 sm:px-14 sm:pt-8 sm:pb-12`}
        style={{ backgroundImage: `url(${freeTrialBannerPng})` }}
      >
        <div className='flex flex-col items-center justify-center gap-4'>
          <div className='flex flex-col items-center gap-2'>
            <div className='inline-flex size-[52px] items-center justify-center rounded-[100px] bg-white/20 p-1.5'>
              <div className='flex items-center justify-center rounded-[100px] bg-white/30 p-2'>
                <img
                  alt='icon speak listening.com'
                  className='relative size-6'
                  src={iconSpeakSvg}
                />
              </div>
            </div>

            <p className='text-[2rem] leading-[2.625rem] font-semibold text-neutral-900'>
              Free trial
            </p>

            <p className='font-["Poppins"] text-lg leading-normal font-normal text-stone-900'>
              Easily pronounces technical words in any field
            </p>
          </div>

          <VoiceSample
            audioSrc={defaultFemaleVoice.sample_url}
            imgSrc={voiceLeslieJpg}
            label='Leslie'
          />

          <BlogCtaButton className='relative inline-block w-full cursor-pointer rounded-full border-0 bg-azure-455 px-8 py-[12px] text-center leading-[21px] font-[600] text-neutral-50 no-underline sm:w-auto lg:text-[16px]' />
        </div>
      </div>
    </section>
  );
}
